import React, { useEffect, useMemo } from "react";
import { Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const WizardStepper = ({
  form,
  formioFormRef,
  formReady,
  currentPage,
  setCurrentPage,
}) => {
   const { t, i18n } = useTranslation();
  // Listen for FormIO page changes
  useEffect(() => {
    if (!formReady) return;

    const instance = formioFormRef.current;
    if (!instance) return;

    const updatePage = () => {
      setCurrentPage(instance.page || 0);
    };

    updatePage();

    instance.on("nextPage", updatePage);
    instance.on("prevPage", updatePage);
    instance.on("gotoPage", updatePage);

    return () => {
      instance.off("nextPage", updatePage);
      instance.off("prevPage", updatePage);
      instance.off("gotoPage", updatePage);
    };
  }, [formReady, formioFormRef, setCurrentPage]);

  // Visible wizard pages
  const steps = useMemo(() => {
    return (form?.components || []).filter((step) => !step.skip);
  }, [form]);

  const progress =
    steps.length > 1
      ? (currentPage / (steps.length - 1)) * 100
      : 0;

  const handleGoTo = async (index) => {
    try {
      if (!formioFormRef.current) return;

      await formioFormRef.current.setPage(index);

      // Optional (gotoPage listener should handle it)
      setCurrentPage(formioFormRef.current.page || index);
    } catch (err) {
      console.error("Failed to navigate to page:", err);
    }
  };

  return (
    <Card className="wizard-card">
      <div className="wizard-container">
        <div className="wizard-steps">
          <div className="wizard-line-bg" />

          <div
            className="wizard-line-fill"
            style={{ width: `${progress}%` }}
          />

          {steps.map((item, index) => {
            const isCompleted = index < currentPage;
            const isActive = index === currentPage;

            return (
              <div
                key={index}
                className="wizard-step-wrapper"
                onClick={() => handleGoTo(index)}
              >
                <div
                  className={`step-circle ${
                    isCompleted ? "done" : ""
                  } ${isActive ? "active" : ""}`}
                >
                  {isCompleted ? "✔" : index + 1}
                </div>

                <div className="step-content">
                  <div className="step-label">
                     {t(item.placeholder || item.label || `Step ${index + 1}`)}
                  </div>

                  <div
  className={`step-status ${
    isCompleted
      ? "completed"
      : isActive
      ? "active"
      : "pending"
  }`}
>
  {isCompleted && t("Completed")}
  {isActive && t("In Progress")}
  {!isCompleted && !isActive && t("Pending")}
</div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </Card>
  );
};

export default WizardStepper;